import { cookiesStorage } from '$utils/services/cookiesStorage'

export const isCookiesStatisticsAcepted = () => {
  return cookiesStorage.getCookie('cookiesStatistics')
}



// WEBPACK FOOTER //
// ./src/services/user/cookiesStatistics/isCookiesAcepted.service.ts